import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {IdCardPage} from './idcard';

@NgModule({
  declarations: [
    IdCardPage,
  ],
  imports: [
    IonicPageModule.forChild(IdCardPage),
  ],
  exports: [
    IdCardPage
  ]
})
export class IdCardPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/idcard/idcard.module.ts